const defaultConfig = {
  apiHost: 'uscapital.ru',
  apiProtocol: 'https',
  apiRoot: '/api/',

  appDomain: 'uscapital.ru',
  appProtocol: 'https',

  SENTRY_DSN: ''
};

function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item) && item !== null);
}

function mergeDeep(target, source) {
  const output = Object.assign({}, target);

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] });
        } else {
          output[key] = mergeDeep(target[key], source[key]);
        }
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }

  return output;
}

const config = mergeDeep(defaultConfig, window.__config);
export default config;



// WEBPACK FOOTER //
// ./src/config/index.js